import { render } from "./CIS-Latest-Advisory.vue?vue&type=template&id=4447c83e&scoped=true"
import script from "./CIS-Latest-Advisory.vue?vue&type=script&lang=js"
export * from "./CIS-Latest-Advisory.vue?vue&type=script&lang=js"

import "./CIS-Latest-Advisory.vue?vue&type=style&index=0&id=4447c83e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4447c83e"]])

export default __exports__